import CloseIcon from "@mui/icons-material/Close";
import { Box, Button, Modal, Typography, IconButton } from "@mui/material";
import React from "react";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 500,
  bgcolor: "background.paper",
  borderRadius: "4px",
  boxShadow: 24,
  p: 4,
};

const ConfirmationModal = ({
  open,
  onClose,
  onConfirm,
  title = "Confirm Delete",
  description = "Are you sure you want to delete these records?",
  confirmText = "Delete",
  cancelText = "Cancel",
}) => {
  return (
    <Modal
      open={open}
      onClose={onClose}
      aria-labelledby="confirmation-modal-title"
      aria-describedby="confirmation-modal-description"
    >
      <Box sx={style}>
        <Box display="flex" alignItems="center" className="pb-2">
          <Typography
            id="confirmation-modal-title"
            variant="h6"
            component="h2"
            className="flex-grow text-center text-xl"
          >
            {title}
          </Typography>
          <IconButton onClick={onClose} size="small" className="-translate-y-4 translate-x-4">
            <CloseIcon />
          </IconButton>
        </Box>
        <Typography id="confirmation-modal-description" className="py-2 text-center">
          {description}
        </Typography>
        <Box className="flex justify-center p-4">
          <Button
            className="border-solid-2 mr-6 border-blue-500 capitalize hover:text-blue-500"
            variant="outlined"
            onClick={onClose}
          >
            {cancelText}
          </Button>
          <Button
            className="border-solid-2 border-red-600 bg-red-600 capitalize text-white hover:bg-gray-50 hover:text-red-600"
            variant="contained"
            onClick={onConfirm}
            color="error"
          >
            {confirmText}
          </Button>
        </Box>
      </Box>
    </Modal>
  );
};

export default ConfirmationModal;
